import apiClient from './apiClient';

export const listMandatari   = ()              => apiClient.get('/mandatari/').then(r => r.data);
export const createMandatar  = (payload)       => apiClient.post('/mandatari/', payload).then(r => r.data);
export const getMandatar     = (id)            => apiClient.get(`/mandatari/${id}/`).then(r => r.data);
export const updateMandatar  = (id, payload)   => apiClient.put(`/mandatari/${id}/`, payload).then(r => r.data);
export const deleteMandatar  = (id)            => apiClient.delete(`/mandatari/${id}/`).then(r => r.data);

// Phase 9 — instruction tracking
export const listMandatarInstructiuni   = (mandatarId)        => apiClient.get(`/mandatari/${mandatarId}/instructiuni/`).then(r => r.data);
export const createMandatarInstructiune = (mandatarId, payload) => apiClient.post(`/mandatari/${mandatarId}/instructiuni/`, payload).then(r => r.data);
export const updateMandatarInstructiune = (id, payload)        => apiClient.patch(`/mandatari/instructiuni/${id}/`, payload).then(r => r.data);
export const deleteMandatarInstructiune = (id)                 => apiClient.delete(`/mandatari/instructiuni/${id}/`).then(r => r.data);
export const uploadMandatarInstructiuneDoc = (id, file) => {
  const form = new FormData();
  form.append('file', file);
  return apiClient.post(`/mandatari/instructiuni/${id}/document/`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then(r => r.data);
};
